import { create } from "zustand";

interface ElementData {
  codebaseId: string;
  filename: string;
  jsxName?: string;
  contentsStart?: number;
  contentsEnd?: number;
}

interface CreateComponentModalStore {
  isOpen: boolean;
  elementData: ElementData | null;
  openModal: (elementData: ElementData) => void;
  closeModal: () => void;
}

export const useCreateComponentModalStore = create<CreateComponentModalStore>(
  (set) => ({
    isOpen: false,
    elementData: null,
    openModal: (elementData) => {
      set({ isOpen: true, elementData });
    },
    closeModal: () => {
      set({ isOpen: false, elementData: null });
    },
  }),
);
